var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_426",
    "data-name": "Rectangle 426",
    width: 20,
    height: 20,
    transform: "translate(0 0)",
    fill: "#15345a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1138",
    "data-name": "Group 1138",
    transform: "translate(0.012 -0.482)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_427",
    "data-name": "Rectangle 427",
    width: 24,
    height: 24,
    transform: "translate(-0.012 0.482)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-bell",
    transform: "translate(2.388 2.082)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M19.087,11.466,17.492,5.729a7.822,7.822,0,0,0-15.172.4L1.086,11.678a4.2,4.2,0,0,0,4.1,5.107h.935a4.2,4.2,0,0,0,8.224,0h.7a4.2,4.2,0,0,0,4.043-5.319Zm-8.858,7a2.518,2.518,0,0,1-2.363-1.678h4.726a2.518,2.518,0,0,1-2.363,1.678Zm6.819-4.351a2.5,2.5,0,0,1-2,.994H5.182a2.518,2.518,0,0,1-2.457-3.064L3.958,6.49a6.144,6.144,0,0,1,11.917-.312l1.595,5.737a2.5,2.5,0,0,1-.421,2.2Z",
    transform: "translate(-0.535 0.028)",
    fill: "#15345a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.3c77cc873a23e4de5b49791a11443f06.svg";
export { ForwardRef as ReactComponent };